<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Trancar Matrícula</h6>
        <i
          class="bi bi-x-circle close-icon"
          @click="fecharModal"
        ></i>
      </div>

      <!-- Conteúdo do Modal -->
      <div class="modal-content">

        <!-- Seção: Contrato do Aluno -->
        <div class="mb-3">
          <h5 class="section-title">Contrato do Aluno</h5>

          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>Aluno</label>

                <input
                  type="text"
                  class="form-control"
                  :value="matricula.aluno_nome"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label>Vigência</label>

                <input
                  type="text"
                  class="form-control"
                  :value="vigenciaTexto"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>Nº do Contrato</label>

                <input
                  type="text"
                  class="form-control"
                  :value="matricula.numero_contrato"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>Nº da Matrícula</label>

                <input
                  type="text"
                  class="form-control"
                  :value="matricula.id"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Período de Trancamento -->
        <div class="mb-3">
          <h5 class="section-title">Período de Trancamento</h5>

          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>
                  Início
                  <span class="required">*</span>
                </label>

                <input
                  type="date"
                  class="form-control"
                  v-model="form.inicio"
                  required
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>
                  Fim
                  <span class="required">*</span>
                </label>

                <input
                  type="date"
                  class="form-control"
                  v-model="form.fim"
                  required
                />
              </div>
            </div>

            <div class="col-md-8">
              <div class="form-group">
                <label>
                  Observações
                  <span class="required">*</span>
                </label>

                <textarea
                  class="form-control"
                  v-model="form.observacoes"
                  rows="1"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Mensagem de erro -->
        <div
          v-if="erroSalvar"
          class="alert alert-danger mt-3 mb-0"
          role="alert"
        >
          {{ erroSalvar }}
        </div>

        <!-- Botão Salvar -->
        <div class="row mt-3">
          <div class="col text-end">
            <button
              :class="[
                'btn',
                isSaving ? 'btn-success' : 'btn-primary'
              ]"
              :disabled="!formIsValid || isSaving"
              @click="salvar"
            >
              {{ isSaving ? 'Salvando…' : 'Salvar' }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/services/axios";
import globalUtils from "@/utils/globalUtils.js";

export default {
  name: "TrancarMatricula",

  props: {
    mostrar: {
      type: Boolean,
      default: false,
    },

    matricula: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {
        inicio: "",
        fim: "",
        observacoes: "",
      },

      // Indica se existe um trancamento futuro
      // que pode ser alterado.
      trancamentoExistente: false,

      // ID do trancamento existente.
      trancamentoId: null,

      // Controle do botão de salvamento.
      isSaving: false,

      // Mensagem apresentada caso haja erro.
      erroSalvar: "",
    };
  },

  computed: {
    vigenciaTexto() {
      const inicio = this.matricula.inicio_vigencia
        ? globalUtils.formatarData(this.matricula.inicio_vigencia)
        : "";

      const termino = this.matricula.termino_vigencia
        ? globalUtils.formatarData(this.matricula.termino_vigencia)
        : "";

      if (!inicio && !termino) {
        return "";
      }

      return `${inicio} a ${termino}`;
    },

    formIsValid() {
      const inicio = this.form.inicio;
      const fim = this.form.fim;
      const observacoes = this.form.observacoes
        ? this.form.observacoes.trim()
        : "";

      if (!inicio || !fim || !observacoes) {
        return false;
      }

      /*
       * Os inputs type="date" trabalham com YYYY-MM-DD.
       * Nesse formato a comparação textual também respeita
       * a ordem cronológica, evitando conversões desnecessárias
       * com new Date().
       */
      return fim >= inicio;
    },
  },

  watch: {
    mostrar(newVal) {
      if (!newVal) {
        return;
      }

      this.resetForm();

      const hojeStr = this.obterDataHojeLocal();

      const inicioTrancamento = this.normalizarData(
        this.matricula.inicio_trancamento
      );

      const terminoTrancamento = this.normalizarData(
        this.matricula.termino_trancamento
      );

      /*
       * Somente considera como trancamento editável aquele
       * cujo início ainda não ocorreu.
       */
      if (
        inicioTrancamento &&
        inicioTrancamento >= hojeStr
      ) {
        this.form.inicio = inicioTrancamento;
        this.form.fim = terminoTrancamento || "";
        this.form.observacoes =
          this.matricula.observacoes_trancamento || "";

        this.trancamentoExistente = true;
        this.trancamentoId =
          this.matricula.trancamento_id || null;

        return;
      }

      this.trancamentoExistente = false;
      this.trancamentoId = null;
    },
  },

  methods: {
    fecharModal() {
      if (this.isSaving) {
        return;
      }

      this.$emit("fechar");
    },

    /*
     * Normaliza datas vindas do backend para YYYY-MM-DD.
     *
     * Aceita, por exemplo:
     *
     * 2026-08-15
     * 2026-08-15T00:00:00.000Z
     *
     * Também aceita DD/MM/YYYY caso algum endpoint
     * antigo retorne a data dessa forma.
     */
    normalizarData(valor) {
      if (!valor) {
        return "";
      }

      const texto = String(valor).trim();

      // YYYY-MM-DD ou ISO completo
      let match = texto.match(
        /^(\d{4})-(\d{2})-(\d{2})/
      );

      if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
      }

      // DD/MM/YYYY
      match = texto.match(
        /^(\d{2})\/(\d{2})\/(\d{4})$/
      );

      if (match) {
        return `${match[3]}-${match[2]}-${match[1]}`;
      }

      return "";
    },

    /*
     * Retorna a data local do navegador no formato YYYY-MM-DD.
     *
     * Não usamos toISOString() porque ele trabalha em UTC
     * e pode trocar o dia dependendo do horário/fuso.
     */
    obterDataHojeLocal() {
      const hoje = new Date();

      const ano = hoje.getFullYear();
      const mes = String(
        hoje.getMonth() + 1
      ).padStart(2, "0");

      const dia = String(
        hoje.getDate()
      ).padStart(2, "0");

      return `${ano}-${mes}-${dia}`;
    },

    resetForm() {
      this.form = {
        inicio: "",
        fim: "",
        observacoes: "",
      };

      this.trancamentoExistente = false;
      this.trancamentoId = null;
      this.isSaving = false;
      this.erroSalvar = "";
    },

    async salvar() {
      if (this.isSaving || !this.formIsValid) {
        return;
      }

      this.isSaving = true;
      this.erroSalvar = "";

      try {
        /*
         * O backend agora é responsável por:
         *
         * - calcular a quantidade de dias;
         * - calcular a diferença de dias em caso de alteração;
         * - recalcular termino_vigencia;
         * - gerar created_at;
         * - gerar updated_at.
         *
         * Portanto o frontend envia somente os dados
         * efetivamente informados/necessários.
         */

        const userName =
          this.$globalState &&
          this.$globalState.userName
            ? this.$globalState.userName
            : null;

        const payload = {
          matricula_id: this.matricula.id,

          aluno: this.matricula.aluno_nome,

          vigencia: this.vigenciaTexto,

          numero_contrato:
            this.matricula.numero_contrato,

          matricula_numero:
            this.matricula.id,

          periodo_trancamento: {
            inicio: this.form.inicio,
            fim: this.form.fim,
            observacoes:
              this.form.observacoes.trim(),
          },

          trancamentoExistente:
            this.trancamentoExistente,

          trancamento_id:
            this.trancamentoId,

          nome_usuario:
            userName,
        };

        console.log(
          "[TrancarMatricula] Enviando trancamento:",
          payload
        );

        const response = await axios.post(
          "/operacional/matriculas-trancamentos",
          payload
        );

        console.log(
          "[TrancarMatricula] Trancamento salvo:",
          response.data
        );

        this.$emit(
          "salvou",
          response.data
        );

        this.fecharModal();

      } catch (error) {
        console.error(
          "[TrancarMatricula] Erro ao salvar trancamento:",
          error
        );

        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          this.erroSalvar =
            error.response.data.error;
        } else {
          this.erroSalvar =
            "Não foi possível salvar o trancamento. Tente novamente.";
        }

      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 60%;
  margin: 0 10px;
  border-radius: 4px;
  overflow: hidden;
}

.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-content {
  padding: 15px;
}

label {
  font-size: 0.8rem;
  font-weight: 500;
}

.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.required {
  color: #dc3545;
}

.alert {
  font-size: 0.85rem;
}
</style>